import * as React from 'react';
import {NoGenericRegistrationScreenType} from '@practicegenius/register-account/src/screens/NoGenericRegistration';
import {BaseScreen} from '../../../components/screens/BaseScreen';

export const NoGenericRegistration: NoGenericRegistrationScreenType = ({
  lang,
}) => (
  <BaseScreen
    headerTitle={lang.headerTitle}
    helmetTitle={lang.pageTitle}
    title={lang.title}
    actionButtons={[
      {
        href: '/home',
        children: lang.buttons.primary.title,
      },
    ]}
    children={
      <>
        <p>{lang.instructions.top}</p>
        <p>{lang.instructions.bottom}</p>
      </>
    }
  />
);
